import { REACT_APP_BETA_ENVIRONMENT } from 'env'
import Styles from './BetaTag.module.scss'
import cx from 'classnames'

export function BetaTag({ notInCore = false }: { notInCore?: boolean }) {
  if (!REACT_APP_BETA_ENVIRONMENT) {
    return null
  }
  return <span className={cx(Styles.betaTag, { [Styles.notInCore]: notInCore })}>(Beta)</span>
}
